import {
  SEARCH_MISS_LIST_ATTEMPT,
  SEARCH_MISS_LIST_SUCCESS,
  SEARCH_MISS_LIST_FAILED,
  SEARCH_MISS_NEW_ATTEMPT,
  SEARCH_MISS_NEW_SUCCESS,
  SEARCH_MISS_NEW_FAILED,
  SEARCH_MISS_WANT_ATTEMPT,
  SEARCH_MISS_WANT_SUCCESS,
  SEARCH_MISS_WANT_FAILED,
} from "../types/searchMissTypes";

function upsertItem(list, item) {
  const next = list.filter((row) => row.Id !== item.Id);
  return [item, ...next];
}

const INITIAL_STATE = {
  list: [],
  loading: false,
  saving: false,
  wantingId: "",
  error: "",
};

function searchMiss(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SEARCH_MISS_LIST_ATTEMPT:
      return { ...state, loading: true, error: "" };

    case SEARCH_MISS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.data.list || [],
        error: "",
      };

    case SEARCH_MISS_LIST_FAILED:
      return { ...state, loading: false, error: action.error, list: [] };

    case SEARCH_MISS_NEW_ATTEMPT:
      return { ...state, saving: true, error: "" };

    case SEARCH_MISS_NEW_SUCCESS:
      return {
        ...state,
        saving: false,
        list: upsertItem(state.list, action.item),
        error: "",
      };

    case SEARCH_MISS_NEW_FAILED:
      return { ...state, saving: false, error: action.error };

    case SEARCH_MISS_WANT_ATTEMPT:
      return { ...state, wantingId: action.id, error: "" };

    case SEARCH_MISS_WANT_SUCCESS:
      return {
        ...state,
        wantingId: "",
        list: state.list.map((item) =>
          item.Id === action.item.Id ? action.item : item
        ),
        error: "",
      };

    case SEARCH_MISS_WANT_FAILED:
      return { ...state, wantingId: "", error: action.error };

    default:
      return state;
  }
}

export default searchMiss;
